import React from "react";
import { motion } from "framer-motion";
import {
  Compass,
  ShieldCheck,
  Users,
  HardHat,
  CircleDollarSign,
  Globe2
} from "lucide-react";
import { useI18n } from "../context/I18nContext";

const ICONS = [Compass, CircleDollarSign, Users, ShieldCheck, HardHat, Globe2];

const WhyUs = () => {
  const { t } = useI18n();
  const items = t("whyUs.items");

  return (
    <section
      id="why"
      className="bg-mayak-bg text-mayak-text relative py-24 lg:py-36 overflow-hidden mayak-grain"
      data-testid="whyus-section"
    >
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, hsl(var(--mayak-accent) / 0.5) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--mayak-accent) / 0.5) 1px, transparent 1px)",
          backgroundSize: "80px 80px"
        }}
      />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <span className="mayak-eyebrow">{t("whyUs.eyebrow")}</span>
            <h2 className="mt-6 font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[1.02] text-mayak-text">
              {t("whyUs.title")}
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-mayak-border">
          {Array.isArray(items) &&
            items.map((it, i) => {
              const Icon = ICONS[i] || Compass;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ delay: i * 0.08, duration: 0.7 }}
                  className="bg-mayak-bg p-8 lg:p-10 hover:bg-mayak-bg-alt transition-colors duration-500 group"
                  data-testid={`why-item-${i}`}
                >
                  <div className="flex items-start justify-between mb-10">
                    <Icon
                      className="text-mayak-accent group-hover:scale-110 transition-transform duration-500"
                      size={28}
                      strokeWidth={1.5}
                    />
                    <span className="font-mono text-xs text-mayak-faint">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-black text-xl lg:text-2xl text-mayak-text tracking-tight mb-4">
                    {it.title}
                  </h3>
                  <p className="text-sm text-mayak-dim leading-relaxed">
                    {it.desc}
                  </p>
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
